var _a;
import { __assign, __awaiter, __extends, __generator, __read, __values } from "tslib";
import { ApiTypes } from '../../types';
import { MediaApi } from '../../services';
import { APP_TOAST_EVENT, AppToastTypes } from '../AppToasts';
import { isAdmin, restrictedByAdmin } from '..';
import { GroupDTO } from './GroupDTO';
import { GroupWrapper } from './GroupWrapper';
import { GroupApps } from '../GroupApps/GroupApps';
var toastsByPrivacyLevel = (_a = {},
    _a[ApiTypes.v1.GroupPrivacyLevel.PUBLIC] = AppToastTypes.GROUP_JOINED,
    _a[ApiTypes.v1.GroupPrivacyLevel.PRIVATE] = AppToastTypes.GROUP_REQUEST_TO_JOIN,
    _a[ApiTypes.v1.GroupPrivacyLevel.SECRET] = AppToastTypes.GROUP_JOINED,
    _a);
/**
 * Model class for wix social groups api
 */
var Group = /** @class */ (function (_super) {
    __extends(Group, _super);
    /**
     * @param {string} id
     * @param {Api} api
     * @param {IPlatformAPI} platformAPIs
     */
    function Group(id, api, platformAPIs) {
        var _this = _super.call(this, Group.createEmpty()) || this;
        _this.id = id;
        _this.api = api;
        _this.platformAPIs = platformAPIs;
        _this.joinGroup = function (group, membershipQuestionsAnswers) {
            if (membershipQuestionsAnswers === void 0) { membershipQuestionsAnswers = null; }
            return __awaiter(_this, void 0, void 0, function () {
                var groupId, privacyLevel, type, requestToJoin;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            groupId = group.groupId, privacyLevel = group.settings.privacyLevel;
                            requestToJoin = !isAdmin(group) && restrictedByAdmin(group);
                            if (!requestToJoin) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.api.requestToJoinPrivateGroup(groupId, membershipQuestionsAnswers)];
                        case 1:
                            _a.sent();
                            type = toastsByPrivacyLevel[privacyLevel];
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, this.api.joinPublicAndSecretGroup(groupId, membershipQuestionsAnswers)];
                        case 3:
                            _a.sent();
                            type = toastsByPrivacyLevel[ApiTypes.v1.GroupPrivacyLevel.PUBLIC];
                            _a.label = 4;
                        case 4:
                            this.showToast({
                                type: type,
                                options: {
                                    'group-name': group.details && group.details.title,
                                },
                            });
                            return [2 /*return*/];
                    }
                });
            });
        };
        _this.leaveGroup = function (group) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.leaveGroup(group.groupId)];
                    case 1:
                        _a.sent();
                        this.showToast({
                            type: AppToastTypes.GROUP_LEFT,
                            options: {
                                'group-name': group.details && group.details.title,
                            },
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.withdrawJoinRequest = function (group) {
            return _this.api.withdrawRequestToJoinPrivateGroup(group.groupId);
        };
        _this.group.groupId = id;
        _this.mediaApi = new MediaApi(api);
        return _this;
    }
    Group.createEmpty = function () {
        return GroupWrapper.createEmpty();
    };
    Group.prototype.fetch = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var data, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.getGroup(this.id)];
                    case 1:
                        data = (_b.sent()).data;
                        this.setGroup(data.group);
                        this.accessRestriction.setRestriction((_a = data.group.settings) === null || _a === void 0 ? void 0 : _a.accessRestriction);
                        return [2 /*return*/, this.group];
                    case 2:
                        e_1 = _b.sent();
                        return [2 /*return*/, Group.createEmpty()];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Group.prototype.setGroup = function (group) {
        _super.prototype.setGroup.call(this, group);
        this.id = this.group.groupId;
    };
    Group.prototype.normalizeJSON = function (object) {
        var e_2, _a;
        var normalized = {};
        try {
            for (var _b = __values(Object.entries(object)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                if (value !== '') {
                    normalized[key] = value;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return normalized;
    };
    /**
     * Creates a group ([Create Group](https://bo.wix.com/wix-docs/rest/business-apis#social-groups.social-groups.create-group))
     * @param {wrapper.wix.social.groups.api.v1.GroupDetails} details
     * @param {wrapper.wix.social.groups.api.v1.GroupSettings} settings
     * @param {File} image
     * @return {Promise<wrapper.wix.social.groups.api.v1.GroupResponse>}
     */
    Group.prototype.create = function (groupId, details, settings, image) {
        if (settings === void 0) { settings = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _details, _a, uploadRes, data, e_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 4, , 5]);
                        _details = this.normalizeJSON(details);
                        if (!image) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.uploadImage(image)];
                    case 1:
                        _a = __read.apply(void 0, [_b.sent(), 1]), uploadRes = _a[0];
                        Object.assign(_details, this.getCover(uploadRes));
                        _b.label = 2;
                    case 2: return [4 /*yield*/, this.api.createGroup(groupId, _details, this.normalizeJSON(settings))];
                    case 3:
                        data = (_b.sent()).data;
                        this.setGroup(data);
                        return [2 /*return*/, this.group];
                    case 4:
                        e_3 = _b.sent();
                        return [2 /*return*/, Group.createEmpty()];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Group.prototype.getRules = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.getRules(this.id)];
                    case 1:
                        response = _a.sent();
                        this.rules = response.data.rules.map(function (rule, id) { return (__assign(__assign({}, rule), { id: id.toString() })); });
                        return [2 /*return*/, this.rules];
                    case 2:
                        e_4 = _a.sent();
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Group.prototype.getRuleTemplates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.getRuleTemplates()];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.rules.map(function (rule, id) { return (__assign(__assign({}, rule), { id: id.toString() })); })];
                    case 2:
                        e_5 = _a.sent();
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Group.prototype.addRule = function (rule) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.rules.push(__assign(__assign({}, rule), { id: this.rules.length.toString() }));
                        return [4 /*yield*/, this.setRules(this.rules)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.rules];
                }
            });
        });
    };
    Group.prototype.updateRule = function (rule) {
        return __awaiter(this, void 0, void 0, function () {
            var ruleIndex;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ruleIndex = this.rules.findIndex(function (_a) {
                            var id = _a.id;
                            return id === rule.id;
                        });
                        this.rules[ruleIndex] = rule;
                        return [4 /*yield*/, this.setRules(this.rules)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.rules];
                }
            });
        });
    };
    Group.prototype.removeRule = function (rule) {
        return __awaiter(this, void 0, void 0, function () {
            var ruleIndex;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ruleIndex = this.rules.findIndex(function (_a) {
                            var id = _a.id;
                            return id === rule.id;
                        });
                        this.rules.splice(ruleIndex, 1);
                        return [4 /*yield*/, this.setRules(this.rules)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.rules];
                }
            });
        });
    };
    Group.prototype.setRules = function (rules) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.updateRules(this.id, rules)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Group.prototype.setClientData = function (key, value) {
        return __awaiter(this, void 0, void 0, function () {
            var clientData, group, e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.updateClientData(this.group.groupId, key, value)];
                    case 1:
                        clientData = (_a.sent()).data.clientData;
                        group = __assign(__assign({}, this.group), { clientData: __assign({}, clientData) });
                        this.group = group;
                        return [3 /*break*/, 3];
                    case 2:
                        e_6 = _a.sent();
                        console.error(e_6);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, this.group];
                }
            });
        });
    };
    Group.prototype.closeAddMembersBanner = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.setClientData('isAddMembersBannerClosed', 'true')];
                    case 1:
                        _a.group = _b.sent();
                        return [2 /*return*/, this.group];
                }
            });
        });
    };
    Group.prototype.uploadImage = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mediaApi.uploadFile(file)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    Group.prototype.update = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, details, settings, approvalStatus, requestDetails, request, e_7;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.group, details = _a.details, settings = _a.settings, approvalStatus = _a.approvalStatus, requestDetails = _a.requestDetails;
                        request = {
                            fieldMask: {
                                paths: this.getUpdatePaths(),
                            },
                            details: details,
                            settings: settings,
                            approvalStatus: approvalStatus,
                            requestDetails: requestDetails,
                        };
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.api.patchGroup(this.group.groupId, request)];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, this.fetch()];
                    case 3:
                        _b.sent();
                        return [2 /*return*/, this.group];
                    case 4:
                        e_7 = _b.sent();
                        return [2 /*return*/, this.fetch()];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Group.prototype.getMembers = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var members, e_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.members.listGroupMembers(this.id, params)];
                    case 1:
                        members = (_a.sent()).data.members;
                        return [2 /*return*/, members];
                    case 2:
                        e_8 = _a.sent();
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Group.prototype.getPendingMembers = function () {
        return __awaiter(this, void 0, void 0, function () {
            var members, e_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.members.listPendingMembers(this.id)];
                    case 1:
                        members = (_a.sent()).data.members;
                        return [2 /*return*/, members];
                    case 2:
                        e_9 = _a.sent();
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Group.prototype.approveMembershipRequests = function (siteMemberIds) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.members.approveGroupMembershipRequests(this.id, siteMemberIds)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Group.prototype.rejectMembershipRequests = function (siteMemberIds) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.members.rejectGroupMembershipRequests(this.id, siteMemberIds)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Group.prototype.setMemberRole = function (request) {
        return this.api.setMemberRole(__assign({ groupId: this.id }, request));
    };
    Group.prototype.removeMembersFromGroup = function (request) {
        return this.api.removeMembersFromGroup(__assign({ groupId: this.id }, request));
    };
    Group.prototype.inviteMembersByEmail = function (emails) {
        return this.api.inviteMembersByEmail({
            groupId: this.id,
            emails: emails,
        });
    };
    Group.prototype.showToast = function (toast) {
        if (this.platformAPIs) {
            this.platformAPIs.pubSub.publish(APP_TOAST_EVENT, toast, false);
        }
    };
    Group.prototype.getApps = function () {
        return __awaiter(this, void 0, void 0, function () {
            var apps, groupApps, e_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.groupAppsApi.getGroupApps(this.id)];
                    case 1:
                        apps = (_a.sent()).data.apps;
                        groupApps = new GroupApps(apps);
                        return [2 /*return*/, groupApps.getAppsMap()];
                    case 2:
                        e_10 = _a.sent();
                        // TODO: log error to sentry
                        console.log('[Group.getApps] error');
                        return [2 /*return*/, {}];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Group.prototype.configureApps = function (apps) {
        return __awaiter(this, void 0, void 0, function () {
            var e_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.groupAppsApi.configureApps(this.id, apps)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.getApps()];
                    case 2:
                        e_11 = _a.sent();
                        return [2 /*return*/, {}];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Group.prototype.setApprovalStatus = function (status, rejectionReason) {
        this.group.approvalStatus = status;
        var fieldMaskPaths = ['approvalStatus'];
        if (status === ApiTypes.v1.GroupApprovalStatus.REJECTED &&
            rejectionReason) {
            if (this.group.requestDetails === undefined) {
                this.group.requestDetails = {};
            }
            this.group.requestDetails.rejectionReason = rejectionReason;
            fieldMaskPaths.push('requestDetails.rejectionReason');
        }
        this.addUpdatePaths(fieldMaskPaths);
        return this.update();
    };
    Group.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.deleteGroup(this.id)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    Group.prototype.getDefaultGroup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, e_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.getDefaultGroup()];
                    case 1:
                        data = (_a.sent()).data;
                        this.group = data.group;
                        this.id = this.group.groupId;
                        return [2 /*return*/, this.group];
                    case 2:
                        e_12 = _a.sent();
                        return [2 /*return*/, Group.createEmpty()];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return Group;
}(GroupDTO));
export { Group };
//# sourceMappingURL=Group.js.map